

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AdminView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminSession } from "@/lib/query/core/invalidation";

type UpdateAdminProfileInput = {
  name?: string;
  email?: string;
  phone?: string;
};

export function useUpdateProfileMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: UpdateAdminProfileInput) =>
      apiJsonClient<AdminView>(endpoints.admin.profile, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
    onSuccess: async () => {
      await invalidateAdminSession(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
